import script from "./map-change.vue?vue&type=script&setup=true&lang=js"
export * from "./map-change.vue?vue&type=script&setup=true&lang=js"

import "./map-change.vue?vue&type=style&index=0&id=aa827004&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa827004"]])

export default __exports__